<div class="row">
    <div [ngClass]="'col-sm-12'"  >
        <mat-expansion-panel expanded="true" class ="panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5>Actualités achats</h5>
              </mat-panel-title>
              <mat-panel-description >
                Bienvenue sur votre outil SACHA
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="paramLandpage && paramLandpage[0] && paramLandpage[0].info">
                <markdown
                    [data]="paramLandpage[0].info">
                </markdown>
            </div>
            <div class="containerButton">
                <ng-container *ngFor="let btn of paramLandpage">
                    <div *ngIf="btn && btn.titreBouton">
                        <a mat-button [disabled]="!btn.haveUrl" href={{btn.urlBouton}} target="_blank" rel="noopener">
                            <button [disabled]="!btn.haveUrl" 
                            [ngClass]="!btn.haveUrl ? 'disabbgwhite' : 'bgwhite'" class="action-button" mat-raised-button>
                            {{btn.titreBouton}}</button></a>
                    </div>
                </ng-container>
            </div>
            </mat-expansion-panel>
    </div>
</div>

<!------------ partie affichage All BC   ----------------->
<div class="row">
    <div class="col-sm-12" [ngClass]="this.bpDisplayState && this.environment ? 'col-sm-12' : 'col-sm-12'">
        <mat-card class="card card-initial">
            <mat-card-header>
                <mat-card-title><h4>{{libelleBC}} saisis</h4></mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
                <div class="align-items-end">
                    <button class="action-button bgwhite" mat-raised-button (click)="addBc()" *ngIf="canEditorCreateBC">
                        <mat-icon>add</mat-icon>Création BC
                    </button>
                    <button class="action-button bgwhite" mat-raised-button (click)="duplicateBc()" *ngIf="canEditorCreateBC">
                        <mat-icon>control_point_duplicate</mat-icon> Dupliquer BC
                    </button>
                    <button class="action-button bgwhite" mat-raised-button (click)="goToMesBcList('list-bc')" *ngIf="canEditorCreateBC">
                        <mat-icon>library_books</mat-icon> Tous Mes BC
                    </button>

                    <button class="action-button bgwhite" mat-raised-button (click)="goToShowMyOrAllBC()" >
                        <mat-icon>filter_list</mat-icon> {{btnVal}}
                    </button>
                </div>
            </mat-card-header>

            <mat-card-content>
                <div class="button-row"  *ngIf="menuAllBC">

                    <mat-card class="sous-card premier" (click)="goToBrouillonBcList('list-bc')">
                        <mat-card-content>

                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <!-- <h1>{{bcDashboard.toBrouillon}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template> -->
                                    </div>
                                    <span style="line-height: 3;"
                                        [innerText]="bcDashboard.toBrouillon > 1 ? 'Brouillons' : 'Brouillon'"></span>
                                </span>
                            </div>

                        </mat-card-content>

                    </mat-card>



                    <mat-card class="sous-card premier" (click)="goToWaitingBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toWaitValidation}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toWaitValidation == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 1;"> En cours <br/> de validation</span>
                                </span>
                            </div>
                        </mat-card-content>

                    </mat-card>

                    <mat-card class="sous-card premier" (click)="goToRecentlyValidatedBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toValideRecent}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toValideRecent == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="bcDashboard.toValideRecent > 1 ? 'Validés récemment' : 'Validé récemment'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="sous-card premier" (click)="goToAReceptionneBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toAReceptionner}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toAReceptionner == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="'À réceptionner'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="sous-card premier" (click)="goToRefusedBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">

                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toRefuse}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toRefuse == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 3;"
                                        [innerText]="bcDashboard.toRefuse > 1 ? 'Refusés' : 'Refusé'"></span>
                                </span>
                            </div>
                        </mat-card-content>

                    </mat-card>

                    <mat-card class="sous-card premier" (click)="goToLitigeBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toLitige}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toLitige == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="'En cours de litige'"></span>
                                </span>
                            </div>
                        </mat-card-content>

                    </mat-card>
                </div>

                  <!--  MENU MES BC -->


                <div class="button-row"  *ngIf="menuMesBc">

                    <mat-card class="sous-card second" (click)="goToBrouillonBcList('list-bc')">
                        <mat-card-content>

                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <!-- <h1>{{bcDashboard.toMyBrouillon}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template> -->
                                    </div>
                                    <span style="line-height: 3;"
                                        [innerText]="bcDashboard.toBrouillon > 1 ? 'Brouillons' : 'Brouillon'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>


                    <mat-card class="sous-card second" (click)="goToWaitingBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toMyWaitValidation}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toMyWaitValidation == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 1;"> En cours <br/> de validation</span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>


                    <mat-card class="sous-card second" (click)="goToRecentlyValidatedBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toMyValideRecent}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toMyValideRecent == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="bcDashboard.toValideRecent > 1 ? 'Validés récemment' : 'Validé récemment'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>


                    <mat-card class="sous-card second" (click)="goToAReceptionneBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toMyAReceptionner}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toMyAReceptionner == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="'À réceptionner'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="sous-card second" (click)="goToRefusedBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">

                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toMyRefuse}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toMyRefuse == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 3;"
                                        [innerText]="bcDashboard.toRefuse > 1 ? 'Refusés' : 'Refusé'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="sous-card second" (click)="goToLitigeBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toMyLitige}}</h1> <br>
                                        <ng-template #emptyDraft>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toMyLitige == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="'En cours de litige'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <br>
</div>
<!---------------------- partie validation  ------------------------------------->
<div class="row">
    <div *ngIf="canValidateBC"
    [ngClass]="{'col-sm-6': (canValidateBP || (this.bpDisplayState && this.environment)), 'col-sm-12': (!canValidateBP || !this.bpDisplayState || !this.environment)}"  >
        <mat-card class="card card-initial">
            <mat-card-header>
                <mat-card-title><h4>Validation BC </h4></mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

                <div class="button-row">


                    <mat-card class="sous-card premier" (click)="goToWaitingValBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toWaitValidationByMe}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bcDashboard.toWaitValidationByMe == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 1;"> En attente de <br/>validation</span>
                                </span>

                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="sous-card premier" (click)="goToRecentlyBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">

                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <!-- <h1>{{bcDashboard.toRecent}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template> -->
                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="bcDashboard.toRecent > 1 ? 'Validé non clos' : 'Validé non clos'"></span>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="sous-card premier" (click)="goToBlockedBcList('list-bc')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bcDashboard.toBloque}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template><mat-spinner *ngIf="bcDashboard.toBloque == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 1;"
                                        [innerText]="bcDashboard.toBloque > 1 ? 'Bloqués' : 'Bloqué'"></span>
                                </span>

                            </div>
                        </mat-card-content>

                    </mat-card>



                </div>
            </mat-card-content>
        </mat-card>
    </div>
  
    <div class="col-sm-6" *ngIf="this.bpDisplayState && this.environment">
        <mat-card class="card card-initial">
            <mat-card-header>
                <mat-card-title><h4>Factures </h4></mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

                <div class="button-row">

                    <mat-card class="sous-card premier" (click)="goToRecentlyBcList('list-bp')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bpDashboard.toRecent}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bpDashboard.toRecent == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>

                                    </div>
                                    <span style="line-height: 2;"
                                        [innerText]="bpDashboard.toRecent > 1 ? 'Reçues récemment' : 'Reçue récemment'"></span>
                                </span>
                            </div>
                        </mat-card-content>

                    </mat-card>



                    <mat-card class="sous-card premier" (click)="goToNonPayeBPList('list-bp')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <!-- <h1>{{bpDashboard.toNonPayee}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template> -->
                                    </div>
                                    <span style="line-height: 1;"
                                    [innerText]="bpDashboard.toNonPayee > 1 ? 'Non payées' : 'Non payée'"></span>
                                </span>
                            </div>
                        </mat-card-content>

                    </mat-card>



                    <mat-card class="sous-card premier" (click)="goToBlockedBcList('list-bp')">
                        <mat-card-content>
                            <div class="resume">
                                <mat-icon style="height: 0px !important;">event_note
                                </mat-icon>
                                <div class="vl"></div>
                                <span class="text">
                                    <div>
                                        <h1>{{bpDashboard.toBloque}}</h1> <br>
                                        <ng-template #emptyToValidate>
                                            <h1>{{myOpenOrderCount}}</h1> <br>
                                        </ng-template>
                                        <mat-spinner *ngIf="bpDashboard.toBloque == undefined" class="spinner" diameter="40" mode="indeterminate"></mat-spinner>
                                    </div>
                                    <span style="line-height: 1;"
                                        [innerText]="bpDashboard.toBloque > 1 ? 'En litige' : 'En litige'"></span>
                                </span>

                            </div>
                        </mat-card-content>

                    </mat-card>

                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>